// extracted by mini-css-extract-plugin
export default {"container":"Service_container__8LwMt","content":"Service_content__3nk9B","services":"Service_services__JQQ+7","get-service":"Service_get-service__-0Ml2"};